import { ReactNode } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "@features/auth/hooks/useAuth.ts"

interface PrivateOutletProps {
  children: ReactNode
}

export const PrivateOutlet = ({ children }: PrivateOutletProps) => {
  const { isAuthenticated } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}
